export const saleContract = "0x2651a3c7d9c82fc66d49339451522c9af920ab0e"
export const privateSaleContract = "0x4a7720601bc7d438de446efb27d5b88527bbeb11"
export const busdContract = "0xe9e7cea3dedca5984780bafc599bd69add087d56"

export const multiCallAddress = "0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B"


export const BASE_BSC_SCAN_URLS = 'https://bscscan.com'
export const BASE_URL = 'https://seed.metaple.finance/'